<template>

<div>
<el-row>
  <el-col :span="24">
    <div class="grid-content bg-purple-light">

      <div class="searchTitle" >
       <b style="font-size: 20px !important;"> 출고 등록</b> <br>
      </div>

      <!-- 조회 조건 영역 -->
      <div class="searchBody">
        <!-- 조회 조건 영역 -->
          <div class="searchBody_year" style="font-size: 15px !important;">
          일자
          </div>
          <div style="margin-left: 10px">
          <el-date-picker
            v-model="confirmStartDateOption"
            type="date"
            placeholder="Pick a day"
            value-format="yyyy-MM-dd"
            class="date-input"
            >
          </el-date-picker>
          ~ 
          <el-date-picker
            v-model="confirmEndDateOption"
            type="date"
            placeholder="Pick a day"
            value-format="yyyy-MM-dd"
            class="date-input"
            >
          </el-date-picker>
          </div>

      </div>



      <div class="searchBody">
        <!-- 조회 조건 영역 -->
          <div class="searchBody_year" style="font-size: 15px !important;">
          운송장번호
        </div>
        <div >
          <el-input
              placeholder=""
              v-model="inputWaybillNumber"
              class="wide-input"
              style="margin-left: 10px;"
          >
          </el-input>
        </div>



          <div class="searchBody_year" style="font-size: 15px !important;">
          QR 코드
        </div>
        <div>
          <el-input
              placeholder=""
              v-model="inputQrCode"
              class="wide-input"
              style="margin-left: 10px;"
          >
          </el-input>
        </div>
      </div>



      <div class="searchBody">
        <!-- 조회 조건 영역 -->
          <div class="searchBody_year" style="font-size: 15px !important;">
          QR 리딩 건수
        </div>

        <div style="margin-left: 10px!important;">
        <el-radio v-model="countFlag"  label="All" style="margin-right: 5px !important; padding-left: 2px !important;">전체</el-radio>
        <el-radio v-model="countFlag"   label="Complete" style="margin-right: 5px !important; padding-left: 2px !important;">리딩완료</el-radio>
          <el-radio v-model="countFlag"   label="Incomplete" style="margin-right: 5px !important; padding-left: 2px !important;">리딩 미완료</el-radio>
          <el-radio v-model="countFlag"   label="Over" style="margin-right: 5px !important; padding-left: 2px !important;">리딩 오버</el-radio>
        </div>

      </div>



      <div class="searchBody"              >

        <div class="searchBody_brand">
          <el-button
            :loading="loading"
            type="primary"
            @click="search"
          >Search</el-button>
          </div>
      </div>


    </div> <!-- div class="grid-content bg-purple-light"> -->
  </el-col>
</el-row>

    <el-row>
        <el-col :span="20">
            <div class="grid-content bg-purple-light" >

 <el-table
    v-loading="loading"
    ref="multipleTable"
    :data="tableData"
    border
    @selection-change="handleSelectionChange"
     :row-class-name="tableRowClassName"
    size="small"
    :row-style="{ height: 0 + 'px' }"
    :cell-style="{ padding: 0 + 'px' }"
    :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '10px',
                          padding: '0px',
                        }"
 >

    <el-table-column
      type="selection"
      width="35"
      >
    </el-table-column>



    <el-table-column
        property="manis_info_seq"
      label="일련번호"
      width="150">


    </el-table-column>



   <el-table-column
       property="waybill_number"
       label="운송장번호"
       width="130">

     <template slot-scope="scope">
       <!--          <el-button @click="handleClick" type="text" size="small">Detail</el-button>-->
       <el-button type="text" size="small" @click="handleClick1(scope.row.waybill_number ) " >
         {{scope.row.waybill_number}}</el-button>
     </template>


   </el-table-column>


   <el-table-column
       property="receiver"
       label="받으시는분"
       width="130">
   </el-table-column>



   <el-table-column
       property="receiver_hp"
       label="받으시는분 전화"
       width="130">
   </el-table-column>



   <el-table-column
       property="total_count"
       label="발송해야할 건수 "
       width="130">
   </el-table-column>


   <el-table-column

       label="qr 리딩 건수 "
       width="130">


     <template slot-scope="scope"   >

       <template v-if="scope.row.qr_code_count == scope.row.total_count  ">
         <div style="background-color:rgb(  180 , 199, 231 ); width: 100%; color: white ">
           {{scope.row.qr_code_count}}
         </div>
       </template>

       <template v-if="scope.row.qr_code_count > scope.row.total_count ">
         <div style="background-color:rgb( 192, 0, 0); width: 100%; color: white">
           {{scope.row.qr_code_count}}
         </div>
       </template>


       <template v-if="scope.row.qr_code_count < scope.row.total_count ">
         <div style="background-color:rgb( 64, 64, 64); width: 100%; color: white">
           {{scope.row.qr_code_count}}
         </div>
       </template>
     </template>
   </el-table-column>




 </el-table>


 <el-row>
  <el-col :span="24"><div class="pagination"  >

<el-pagination
  small
  layout="prev, pager, next"
      :total="totalSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
  >
</el-pagination>


      <el-button
    :loading="loading"
    type="primary"
    @click="dialogVisible=true"
  >출고 엑셀 파일 업로드</el-button>



    <el-button
        :loading="loading"
        type="primary"
        @click="dialogVisible2=true"
    >출고 </el-button>


    <el-tag type="warning" effect="dark"  style="margin-left: 10px; height: 30px"> COUNT : {{this.totalData.length}}</el-tag>


    <el-button
        :loading="loading"
        type="primary"
        @click="excelDownFuncAll"
        style="margin-left: 10px"
    > 엑셀 다운로드 </el-button>


  </div> <!-- div class="grid-content bg-purple-light"> -->
  </el-col>
 </el-row>

    <el-dialog
  title="발행결과 파일 업로드"
  :visible.sync="dialogVisible"
  width="30%"
  v-loading="loading"
  :before-close="Confirm"
  :close-on-click-modal="false"
  >
    <span class="text-reader">
      <form ref="form">

      <input type="file" @change="filesChange" class="FileUpload__default" accept=".xlsx" multiple  />
      </form>
    </span>

    <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
    <el-button type="primary" @click="Confirm">Confirm</el-button>
  </span>


</el-dialog>





    <el-dialog
        title="출고"
        :visible.sync="dialogVisible2"
        width="30%"
        v-loading="loading"
        :before-close="Confirm2"
        :close-on-click-modal="false"
    >
        <el-row  class="row-bg" >
            <el-col :span="23">
                <div  style="margin-top: 20px">

      <el-input
          id="textarea_class"
          class="textarea_class"
          type="textarea" v-model="qrcode"></el-input>

                    <div  style="margin-top: 10px">
    <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
    <el-button type="primary" @click="qrSave">Confirm</el-button>
                </div>
            </div>
        </el-col>
    </el-row >

    </el-dialog>




    <el-dialog
        title="개별 출고"
        :visible.sync="dialogVisible3"
        width="30%"
        v-loading="loading"
        :before-close="Confirm3"
        :close-on-click-modal="false"
    >
        <el-row  class="row-bg" >
            <el-col :span="23">
                <div  style="margin-top: 20px">

      <el-input
          id="textarea_class"
          class="textarea_class"
          type="textarea" v-model="qrcode2"></el-input>



          <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
                    <div  style="margin-top: 10px">
          <el-button type="primary" @click="qrSave2">Confirm</el-button>
                    </div>
                </div>
            </el-col>
        </el-row >

    </el-dialog>




  </div>
 </el-col>
 </el-row>

</div>
</template>


<script>
import Axios from 'axios';
import XLSX from "xlsx";


  export default {
    created() {
      this.$store.commit("dayBefore",0);
      this.confirmEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜 
      this.$store.commit("dayBefore",7);
      this.confirmStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일
      if (this.$store.state.userId != 'admin') {
        // this.deptSeqOption = this.$store.state.deptSeq;
        // this.deptNameOption = this.$store.state.deptName;
      }

      // console.log()
      // 페이지로딩시 조회
      this.search();
      // this.getFilePath();
    },//created    
    data() {
      return {
        // table 관련 data 
        tableData: [],
        totalData: [],
        totalData2: [],
        tableData2:[],
        multipleSelection: [],
        multipleTable2 :[],

        saveData:[],
        saveData2:[],
        currentPage: 1,
        pageSize:10,
        totalSize:0,

        // loading 변수 true 이면 loging 화면 보여줌
        loading:false,

        statusOptions: [{

          value: 'I',
          label: '입고'
        },
          {
          value: 'O',
          label: '출고'
        }, ],
        brandOption: '',
        styleOption :'',
        deptNameOption:'',
        deptSeqOption:0,
        confirmStartDateOption:'',
        confirmEndDateOption:'',
        statusOption:'입고',
        status:'',     
        fileList: [],
        text :[],
        dialogVisible: false,
        dialogVisible2:false,
        dialogVisible3:false,
        statusLavel:'',
        filePath:'',
        epc :'',
        member_id :'',
        member_name : '',
        chkOutDate : false,
        items : [],
        excelJsonData :  [],
        qrcode : '',
        qrcode2 : '',
        inputQrCode : '',
        inputWaybillNumber : '',
        countFlag:'All',
        waybill_number : ''


      } // return 
    },// data

    methods: {

      handleClick1(waybill_number ){
        this.search2(waybill_number);
      },


      async search2(waybill_number) {
        this.loading = true;
        this.dialogVisible2 = false;
        this.dialogVisible3 = false;
        this.waybill_number = waybill_number;

        // default data
        let url = this.$url + '/manisInfo/getQrList';
        var reqJson = new Object();

        reqJson.waybill_number = waybill_number;

        //console.log("============================================================") ;
        //console.log(reqJson) ;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.manisInfoDTO;

          //console.log("=====222222222222222222================") ;
          //console.log(resDataJson) ;

          this.qrcode2 = "";
          this.qrcode2 = waybill_number + '\n'

          for(var resData in resDataJson){

            this.qrcode2 = this.qrcode2 + resDataJson[resData]['qr_code'] + '\n'

          }

          //console.log("=====233333333333333332================") ;
          //console.log(this.qrcode2) ;


          // this.tableData2 =  this.totalData2
          //

          this.loading = false;
          this.dialogVisible3 = true;

        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.loading = false;
            }); // await Axios.post
      },//



      async search(){
        this.loading = true;

        // default data 
        let url = this.$url + '/manisInfo/list';
        var reqJson = new Object();


        reqJson.in_start_date = this.confirmStartDateOption;
        reqJson.in_end_date = this.confirmEndDateOption;
        reqJson.qr_code = this.inputQrCode;
        reqJson.waybill_number = this.inputWaybillNumber;

        // reqJson.status = 'I';
        // reqJson.company_name =  this.$store.state.hospitalname;

        // if (this.$store.state.accessToken != '100')
        //   reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;

        //console.log("============================")
        //console.log(reqJson.status);

        if (this.countFlag != "All")
          reqJson.count_flag  = this.countFlag ;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {  
          var resDataJson = res.data.manisInfoDTO;
          this.totalData=[];

          if (res.data.resultCode){

            for (var resData in resDataJson) {

                this.totalData.push({
                  seq: resData  * 1 + 1
                  , manis_info_seq: resDataJson[resData]['manis_info_seq']
                  , waybill_number : resDataJson[resData]['waybill_number']
                  , receiver : resDataJson[resData]['receiver']
                  , receiver_hp : resDataJson[resData]['receiver_hp']
                  , total_count : resDataJson[resData]['total_count']
                  , qr_code_count : resDataJson[resData]['qr_code_count']
                  , qr_code : resDataJson[resData]['qr_code']
                });

            }
            // 전체 데이터 사이즈 
            this.totalSize = this.totalData.length;
            // 보여주는 부분만 slice 
            this.tableData = this.totalData.slice(0, this.pageSize);
            this.currentPage = 1;
            this.loading = false;
            this.status = reqJson.status;
            this.$message.success(this.$store.state.searchSuccess);
          }else{
            this.$message.error(this.$store.state.dataNotFound);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
        .catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      },//search

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      }, //toggleSelection

      // check box click event 
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 1) {
        //  return 'warning-row';
        } else if (rowIndex === 3) {
        //  return 'success-row';
        }
         console.log(row);
        return '';
      },    
      handleSizeChange(val) {
        console.log(`${val} items per page`);
      },

      // pagging event 
      handleCurrentChange(val) {
        this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
      },
      //
      // async excelDownFunc(){
      //
      //   if(this.multipleSelection==null || this.multipleSelection.length == 0 ){
      //     this.$message.error(this.$store.state.noDataSelect);
      //     return ;
      //   }
      //
      //   this.loading = true;
      //
      //   // default data
      //   let url = this.$url + '/rfidInfo/reDowload';
      //   // var reqJson = new Object();
      //
      //   await Axios.post(url, this.multipleSelection , this.$store.state.config ).then(res => {
      //     let saveCount = res.data;
      //
      //
      //     if (saveCount){
      //       this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
      //       this.loading = false;
      //
      //     }else{
      //       this.$message.error(this.$store.state.serverErrorMessage);
      //       this.currentPage = 1;
      //       this.loading = false;
      //     }
      //   }) // await Axios.post
      //       .catch(error => {
      //         console.log(error.response)
      //         this.$message.error(this.$store.state.serverErrorMessage);
      //         this.currentPage = 1;
      //         this.loading = false;
      //       }); // await Axios.post
      //
      //
      // }, //excelDownFunc



      async pathUpload(){


        this.loading = true;

        // default data
        let url = this.$url + '/saveInfo/pathUpdate';
        var reqJson = new Object();


        reqJson.file_full_path = this.filePath;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          let saveCount = res.data;

          if (saveCount){
            this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
            this.loading = false;

          }else{
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.currentPage = 1;
              this.loading = false;
            }); // await Axios.post


      }, //excelDownFunc

      getCheckSum(hex)
      {
        var chk = hex.length
        var value = 0;
        for(var i=0; i <hex.length; i += 2) {
          value +=  parseInt(hex.substring(i, i+2),16) * chk
          chk ++;
        }
        var res = value * 1224 % 100;
        if (res <= 9)
          return '0' + res;
        else
          return res;
      },

      convertToHex(str) {
          var hex = '';
          for(var i=0;i<str.length;i++) {
            hex += str.charCodeAt(i).toString(16);
          }
        return hex;
      },

      convertToString(hex) {

        //console.log("convertToString");
        //console.log(hex);

        var str = '';
        for(var i=0;i<hex.length; i += 2) {
          str += String.fromCharCode(parseInt(hex.substring(i, i+2),16))
        }
        return str;
      },

      filesChange(event) {
        // get File object from input tag
        this.loading = true;

        const file = event.target.files[0];
        let reader = new FileReader();
        let tmpResult = {};
        reader.onload = (e) => {

          console.log(e);

          let data = reader.result;
          let workbook = XLSX.read(data, {type: 'binary'});
          workbook.SheetNames.forEach(sheetName => {
            workbook.Sheets[sheetName].A1.w = "region";
            workbook.Sheets[sheetName].B1.w = "waybill_number";
            workbook.Sheets[sheetName].C1.w = "sender";
            workbook.Sheets[sheetName].D1.w = "sender_hp";

            workbook.Sheets[sheetName].E1.w = "sender_manager";
            workbook.Sheets[sheetName].F1.w = "sender_manager_hp";
            workbook.Sheets[sheetName].G1.w = "sender_zip_code";
            workbook.Sheets[sheetName].H1.w = "sender_address";

            workbook.Sheets[sheetName].I1.w = "receiver";
            workbook.Sheets[sheetName].J1.w = "receiver_hp";
            workbook.Sheets[sheetName].K1.w = "receiver_manager";
            workbook.Sheets[sheetName].L1.w = "receiver_manager_hp";

            workbook.Sheets[sheetName].M1.w = "receiver_zip_code";
            workbook.Sheets[sheetName].N1.w = "receiver_address";
            workbook.Sheets[sheetName].O1.w = "fare_type";

            workbook.Sheets[sheetName].P1.w = "payment_type";
            workbook.Sheets[sheetName].Q1.w = "release_number";


            workbook.Sheets[sheetName].R1.w = "remark";

            workbook.Sheets[sheetName].S1.w = "memo1";
            workbook.Sheets[sheetName].T1.w = "memo2";

            workbook.Sheets[sheetName].U1.w = "memo3";
            workbook.Sheets[sheetName].V1.w = "memo4";

            workbook.Sheets[sheetName].W1.w = "lbl_hub_code";
            workbook.Sheets[sheetName].X1.w = "product_name1";
            workbook.Sheets[sheetName].Y1.w = "product_count1";


            workbook.Sheets[sheetName].Z1.w = "product_name2";
            workbook.Sheets[sheetName].AA1.w = "product_count2";
            workbook.Sheets[sheetName].AB1.w = "product_name3";
            workbook.Sheets[sheetName].AC1.w = "product_count3";


            workbook.Sheets[sheetName].AD1.w = "product_name4";
            workbook.Sheets[sheetName].AE1.w = "product_count4";
            workbook.Sheets[sheetName].AF1.w = "product_name5";
            workbook.Sheets[sheetName].AG1.w = "product_count5";

            workbook.Sheets[sheetName].AH1.w = "product_name6";
            workbook.Sheets[sheetName].AI1.w = "product_count6";
            workbook.Sheets[sheetName].AJ1.w = "product_name7";
            workbook.Sheets[sheetName].AK1.w = "product_count7";



            workbook.Sheets[sheetName].AL1.w = "product_name8";
            workbook.Sheets[sheetName].AM1.w = "product_count8";

            workbook.Sheets[sheetName].AN1.w = "product_name9";


            workbook.Sheets[sheetName].AO1.w = "product_count9";
            workbook.Sheets[sheetName].AP1.w = "product_name10";
            workbook.Sheets[sheetName].AQ1.w = "product_count10";
            workbook.Sheets[sheetName].AR1.w = "product_name11";


            workbook.Sheets[sheetName].AS1.w = "product_count11";
            workbook.Sheets[sheetName].AT1.w = "product_name12";


            workbook.Sheets[sheetName].AU1.w = "product_count12";


            workbook.Sheets[sheetName].AV1.w = "product_name13";


            workbook.Sheets[sheetName].AW1.w = "product_count13";
            workbook.Sheets[sheetName].AX1.w = "product_name14";
            workbook.Sheets[sheetName].AY1.w = "product_count14";
            workbook.Sheets[sheetName].AZ1.w = "product_name15";




            workbook.Sheets[sheetName].BA1.w = "product_count15";
            workbook.Sheets[sheetName].BB1.w = "product_name16";
            workbook.Sheets[sheetName].BC1.w = "product_count16";
            workbook.Sheets[sheetName].BD1.w = "product_name17";
            workbook.Sheets[sheetName].BE1.w = "product_count17";
            workbook.Sheets[sheetName].BF1.w = "product_name18";


            workbook.Sheets[sheetName].BG1.w = "product_count18";
            workbook.Sheets[sheetName].BH1.w = "product_name19";
            workbook.Sheets[sheetName].BI1.w = "product_count19";
            workbook.Sheets[sheetName].BJ1.w = "product_name20";


            workbook.Sheets[sheetName].BK1.w = "product_count20";
            workbook.Sheets[sheetName].BL1.w = "product_name21";
            workbook.Sheets[sheetName].BM1.w = "product_count21";
            workbook.Sheets[sheetName].BN1.w = "product_name22";


            workbook.Sheets[sheetName].BO1.w = "product_count22";
            workbook.Sheets[sheetName].BP1.w = "product_name23";
            workbook.Sheets[sheetName].BQ1.w = "product_count23";


            workbook.Sheets[sheetName].BR1.w = "product_name24";
            workbook.Sheets[sheetName].BS1.w = "product_count24";
            workbook.Sheets[sheetName].BT1.w = "product_name25";
            workbook.Sheets[sheetName].BU1.w = "product_count25";


            workbook.Sheets[sheetName].BV1.w = "product_name26";
            workbook.Sheets[sheetName].BW1.w = "product_count26";


            //console.log(workbook.Sheets[sheetName].A1);
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            tmpResult = roa;
          });

          //console.log("=====================================");
          //console.log(tmpResult);
          this.excelJsonData=tmpResult;


          let url = "";
          url = this.$url + '/manisInfo/insert';

          Axios.post(url, this.excelJsonData , this.$store.state.config  ).then(res => {

            //console.log(res);
            let saveCount = res.data;
            this.loading = false;
            this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
            this.search();
            // this.$refs.myFiles.files[0].name = null;
          }).catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post



        };
        reader.readAsBinaryString(file);
              
      },//filesChange

      Confirm(){
        // this.e.target.files[0].name = "";

        this.$refs.form.reset() ;
        this.dialogVisible = false;
        this.dialogVisible2 = false;

      },

      Confirm2(){
        // this.e.target.files[0].name = "";

        //console.log ("Confirm2") ;
        this.qrcode = "";
        this.dialogVisible2 = false;

      },

      Confirm3(){
        // this.e.target.files[0].name = "";

        this.qrcode2 = "";
        this.dialogVisible3 = false;

      },


      qrSave(){

        this.loading = true;
        // this.e.target.files[0].name = "";

        var array = this.qrcode.split('\n');

        var resDataJson = [];

        for ( var idx = 0 ; idx < array.length  ; idx++ ) {
              resDataJson.push({
                 qr_code: array[idx]
              });
        }

        let url = this.$url + '/manisInfo/qrInsert';

        Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search();
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.loading = false;
        }); // await Axios.post

      },



      qrSave2(){
        // this.e.target.files[0].name = "";

        var array = this.qrcode2.split('\n');

        var resDataJson = [];

        for ( var idx = 0 ; idx < array.length  ; idx++ ) {
          resDataJson.push({
            qr_code: array[idx]
          });
        }


        //console.log ("test ")
        //console.log (array.length )
        //console.log (array[0].trim() )

        if (array.length  <= 1 && array[0].trim() == "")
        {
          resDataJson = [];
          resDataJson.push({
            qr_code: this.waybill_number
          });
        }

        //console.log (resDataJson )

        let url = this.$url + '/manisInfo/qrInsert2';

        Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search();
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.loading = false;
        }); // await Axios.post

      },


      submitUpload() {
        this.$refs.upload.submit();
      },

      excelDownFuncAll(){
        var excepData = [];

        for (var i in this.totalData) {
          excepData.push({
            운송장번호 : this.totalData[i]['waybill_number']
            ,받으시는분 : this.totalData[i]['receiver']
            ,받으시는분전화 : this.totalData[i]['receiver_hp']
            ,발송해야할건수 : this.totalData[i]['total_count']
            ,qr리딩건수 : this.totalData[i]['qr_code_count']
            ,QRCODE :  (this.totalData[i]['qr_code'] == null || this.totalData[i]['qr_code'] == ''  ?  this.totalData[i]['qr_code']  : this.totalData[i]['qr_code'].substr(1) )
          });
        }

        this.loading = true;
        var dataWS = XLSX.utils.json_to_sheet(excepData);
        var wb = XLSX.utils.book_new();
        // workbook에 워크시트 추가
        // 시트명은 'nameData'
        XLSX.utils.book_append_sheet(wb, dataWS, '출고등록');
        // 엑셀 파일을 내보낸다.
        this.$store.commit("dayBefore",0); // 오늘날짜
        XLSX.writeFile(wb, "출고등록"+'.xlsx');
        this.loading = false;
      },//excelDownFunc

    }, //methods
  }
</script>


<style>


.textarea_class {
  height: 300px !important;
}

.el-textarea__inner {

  height: 100% !important;

}



.searchBody_production {
  width: 100px !important;
  margin-left: 20px !important;
}

</style>

